import script from "./BenefitCalculator.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenefitCalculator.vue?vue&type=script&setup=true&lang=ts"

import "./BenefitCalculator.vue?vue&type=style&index=0&id=24c971c5&lang=scss"

const __exports__ = script;

export default __exports__